import React, { ReactElement } from 'react'
import { Card } from 'ktr-materialui-react';
import { makeStyles, Grid } from '@material-ui/core';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import Values from '../../react-intl/FMValues';
import * as Utils from '../../Utils';
import WithAxialHubShifting from './WithAxialHubShifting';
import WithoutAxialHubShifting from './WithoutAxialHubShifting';
import IMG_SelfCentered from '../../images/selfcentered.png';
import IMG_SelfCenteredWithAxial from '../../images/with-axial.png';
import IMG_NotSelfCentered from '../../images/without-axial.png';
import IMG_NotSelfCenteredWithAxial from '../../images/without-axial-after-assembly.png';


import CardMedia from '@material-ui/core/CardMedia';

const useStyle = makeStyles({
  card: {
    margin: "10px",
    minHeight: "380px",
    maxWidth: "450px"
  },
  image: {
    width: "190px",
  }
});

export default function SelfCentering(): ReactElement {
  const classes = useStyle();
  let { path, url } = useRouteMatch();
  const { formatMessage: f } = useIntl();


  return (
    <React.Fragment>
      <h2>{f({ id: 'app.selfcent.head' })}</h2>
      <Grid container style={{ marginTop: "20px" }} justify="center">
        <Grid item>
          <Card
            className={classes.card}
            heading={<FormattedMessage id='app.selfcent.heading' values={Values} />}
            content={<FormattedMessage id='app.selfcent.content' values={Values} />}
            buttonText={f({ id: 'app.btn.forward' })}
            header={
              <Grid container style={{ margin: "20px" }}>
                <Grid item md={5} xs={12}>
                  <Grid item xs={12}>
                    <CardMedia
                      component="img"
                      className={classes.image}
                      height="140"
                      image={IMG_SelfCentered}
                    />
                  </Grid>
                  <Grid style={{ textAlign: "center" }} item xs={12}>
                    <FormattedMessage id='app.hub.beforeassembly' values={Values} />
                  </Grid>
                </Grid>
                <Grid item md={5} xs={12}>
                  <Grid item xs={12}>
                    <CardMedia
                      component="img"
                      className={classes.image}
                      height="140"
                      image={IMG_SelfCenteredWithAxial}
                    />
                  </Grid>
                  <Grid style={{ textAlign: "center" }} item xs={12}>
                    
                    <FormattedMessage id='app.hub.afterassembly2' values={Values} />
                  </Grid>

                </Grid>
              </Grid>
            }
            onClick={(event) => Utils.openLink("#" + url + "/axialhs")}
          />
        </Grid>
        <Grid item>
          <Card
            className={classes.card}
            heading={<FormattedMessage id='app.woselfcent.heading' values={Values} />}
            content={<FormattedMessage id='app.woselfcent.content' values={Values} />}
            buttonText={f({ id: 'app.btn.forward' })}
            header={
              <Grid container style={{ margin: "20px" }}>
                <Grid item md={5} xs={12}>
                  <Grid item xs={12}>
                    <CardMedia
                      component="img"
                      className={classes.image}
                      height="140"
                      image={IMG_NotSelfCentered}
                    />
                  </Grid>
                  <Grid style={{ textAlign: "center" }} item xs={12}>
                    <FormattedMessage id='app.hub.beforeassembly' values={Values} />
                  </Grid>
                </Grid>
                <Grid item md={5} xs={12}>
                  <Grid item xs={12}>
                    <CardMedia
                      component="img"
                      className={classes.image}
                      height="140"
                      image={IMG_NotSelfCenteredWithAxial}
                    />
                  </Grid>
                  <Grid style={{ textAlign: "center" }} item xs={12}>
              
                    <FormattedMessage id='app.hub.afterassembly3' values={Values} />
                  </Grid>

                </Grid>
              </Grid>
            }
            onClick={(event) => Utils.openLink("#" + url + "/woaxialhs")}
          />
        </Grid>
      </Grid>
      <Switch>
        <Route path={`${path}/axialhs`} component={WithAxialHubShifting}></Route>
        <Route path={`${path}/woaxialhs`} component={WithoutAxialHubShifting}></Route>
      </Switch>
    </React.Fragment>
  )
}
